import { Component,  OnInit, OnDestroy, Input } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AssetService } from "src/app/_services/asset.service";
import { CustomersService } from "src/app/_services/customers.service";
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { SiteService } from "src/app/_services/site.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { resolveSoa } from 'dns';

@Component({
  selector: "app-create-contract-in-block",
  standalone: false,
  templateUrl: "./create-contract-in-block.component.html",
  styleUrl: "./create-contract-in-block.component.scss",
})
export class CreateContractInBlockComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  contractName: string = "";
  customer: any = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  minEndDate: Date | null = null;
  maxStartDate: Date | null = null;
  autoGenerateJobOrders: boolean = true;
  generationFrequency: string = "weekly"; // default pill
  generateOnDay: any = null;
  generateDaysBefore: number | null = null;

  customerOptions: any[] = [
    { label: "BSM John", value: "bsm-john" },
    // populated from service later
  ];

  dayOfWeekOptions: any[] = [
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  dayOfMonthOptions: any[] = Array.from({ length: 31 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1,
  }));
  selectedCustomer: any;
  displayTable: boolean = false;
  customers: any = [];
  users: any;
  contractForm!: FormGroup;
  data: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private assetServc: AssetService,
    private customerServc: CustomersService,
    private siteService: SiteService,
    private errorUtil: ErrorUtil,
    private util: UtilServiceService,
    private modalServc: BsModalService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    console.log(this.data,'data printing..')
    this.selectedCustomer = {name: this.data.customerName, id: this.data.customerId};
    this.contractForm = new FormGroup({
      contractName: new FormControl("", [
        Validators.required,
       // Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/),
        Validators.pattern("^(?=.*[a-zA-Z0-9]).+$")
      ]),
      customer: new FormControl(this.selectedCustomer, [Validators.required]),
      startDate: new FormControl(new Date(), [Validators.required]),
      endDate: new FormControl(null, [Validators.required]),
    });

    //for setting the selectable values of endDate calendar
    let minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);
    this.minEndDate = minDate;
  }
  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  selectGenerationFrequency(freq: string) {
    this.generationFrequency = freq;
    this.generateOnDay = null; // reset since options differ between weekly/monthly
  }

  gotSelectedCustomer(valueCust: any) {
    var val = valueCust.value ? valueCust.value : valueCust;
    this.customers = [val];

    this.selectValue(val);
    this.displayTable = false;
  }
  getCustomerIdsFirstWay(event: any) {
    const query = event.query.replace(
      /[&\/\\#,+()$~%!.„'":*‚^_¤?<>|@ª{«»§}©®™ ]/g,
      "",
    );

    if (query != null && query.length > 2) {
      super.push(
        this.customerServc
          .getAllCustomerByName(query)
          .subscribe((customers: any) => {
            this.customers = customers;
          }),
      );
    }
  }

  selectValue(value: any) {
    this.getUsers(value.id); //custodian,SO picklist
    // this.contract.customer.id = value.id;
    // this.contract.customer.name = value.name;
    this.selectedCustomer = value;
    this.contractForm.patchValue({ customer: value.name });
  }

  getUsers(id: any) {
    super.push(
      this.assetServc.getCustodians(id).subscribe((res: any) => {
        this.users = res.body;
      }),
    );
  }

  clearValue() {
    //this.contract.customer.id = null;
    this.selectedCustomer = null;
    this.contractForm.controls["customer"].reset();
    this.contractForm.controls["customer"].updateValueAndValidity();
    this.customers = [];
  }

  showTable() {
    this.displayTable = !this.displayTable;
  }

  onStartDateSelect(e: any) {
    const startDate = this.contractForm.controls["startDate"].value;
    if (!startDate || startDate == "") {
      this.minEndDate = null;
    } else {
      const minDate = new Date(startDate);
      minDate.setDate(minDate.getDate() + 1);
      this.minEndDate = minDate;
    }
  }

  onEndDateSelect(e: any) {
    //set the maxStartDate to be the day before the selected end date
    const endDate = this.contractForm.controls["endDate"].value;
    if (!endDate || endDate == "") {
      this.maxStartDate = null;
    } else {
      const maxDate = new Date(endDate);
      maxDate.setDate(maxDate.getDate() - 1);
      this.maxStartDate = maxDate;
    }

  }

  onContractCreate() {
    if (this.contractForm.valid) {
      let endDate: Date = new Date(this.contractForm.get("endDate")?.value);
      endDate.setHours(23, 59, 59);

      let payload: any = {
        contractName: this.contractForm.get('contractName')?.value,
        customer: {
          id: this.selectedCustomer.id,
          name: this.selectedCustomer.name,
        },
        active: true,
        status: "NEW",
        startDateTime: this.util.formatDateToISOString(
          this.contractForm.get("startDate")?.value,
        ),
        endDateTime: this.util.formatDateToISOString(endDate)
      };

      this.siteService.createContract(payload).subscribe({
        next: (res: any) => {
          console.log(res, "response printing for create contract..");
          if (res.status == 200 || res.status == 201) {
            //call GET contract by id
            this.assetServc.getViewContract(res.body.id).subscribe({
              next: (response: any) =>{
                let contractInfo: any = response.body;
                contractInfo['startDate'] = this.util.formatISOStringToDate(
                  contractInfo.startDateTime,
                );
                contractInfo.endDate = this.util.formatISOStringToDate(
                  contractInfo.endDateTime,
                );

                let jsonObj: any = {
                  layer: this.data?.layer,
                  reason: "contractCreated",
                  contract: contractInfo,
                };
                this.modalServc.setDismissReason(JSON.stringify(jsonObj));
                this.modalRef.hide();
              },
              error: (error: any) =>{
                let errorTitle: string = error.error.title;
                this.errorUtil.setErrorMessage(
                  error.status,
                  null,
                  errorTitle,
                  "error",
                  2000,
                );
              }
            });
          }
        },
        error: (err: any) => {
          let errorTitle: string = err.error.title;
          this.errorUtil.setErrorMessage(
            err.status,
            null,
            errorTitle,
            "error",
            2000,
          );
        },
      });
    } else {
      this.contractForm.markAllAsTouched();
    }
  }

  closeCustomerView() {
    this.displayTable = false;
  }
}
